import { ProductTypes } from 'utils/enums';
import { useEffect, useState } from 'react';
import { getAffiliateDetails } from 'store/actions/affiliates';
import { useDispatch, useSelector } from 'react-redux';
import useAffiliateId from 'hooks/useAffiliateId';
import useAuthentication from './useAuthentication';

export const getProductPrice = product => {
    if (product.price) {
        if (product.price.now) {
            return product.price.now;
        }
        if (product.price.standard) {
            return product.price.standard;
        }
        if (product.type === ProductTypes.Subscription) {
            return product.price.yearly ?? product.price.monthly ? product.price.monthly?.standard : 0;
        }
    }

    return 0;
};

export const useProducts = (affiliateId, productsToShow) => {
    const [products, setProducts] = useState(null);
    const { initialized, authenticated } = useAuthentication();
    const [localStorageAffiliateId] = useAffiliateId();
    const userAffiliateId = useSelector(state => state.user?.preferences?.affiliates?.activeAffiliateId);
    const activeAffiliateId = affiliateId || userAffiliateId || localStorageAffiliateId;
    const dispatch = useDispatch();
    useEffect(() => {
        const run = async () => {
            if(initialized){
                const affiliate = await dispatch(getAffiliateDetails(activeAffiliateId || 'penly'));
                const affiliateProducts = affiliate?.products;
                if (affiliateProducts) {
                    const filtered = productsToShow ? productsToShow.reduce((obj, key) => {
                        obj[key] = affiliateProducts[key];
                        return obj;
                    }, {}) : affiliateProducts;
                    setProducts(filtered);
                };
            }
        };
        run();
    }, [activeAffiliateId, dispatch, initialized, authenticated]);
    return products;
};
